import {
  TextButton as TextButtonBase,
  type TextButtonProps as TextButtonBaseProps,
} from "@clipboard-health/ui-components";
import { type ReactNode } from "react";

import { ButtonInternalLink } from "./ButtonInternalLink";

export { TEXT_BUTTON_SIZES } from "@clipboard-health/ui-components";

export interface TextButtonProps extends Omit<TextButtonBaseProps, "LinkComponent"> {
  children?: ReactNode;
}

export function TextButton(props: TextButtonProps) {
  return <TextButtonBase {...props} LinkComponent={ButtonInternalLink} />;
}
